import { ActionLink } from '../../../components/ActionLink'
import type { TodoGroup } from './homeModel'
import styles from './home.module.css'

/**
 * Everything waiting on the viewer, under the team or org it belongs to.
 *
 * The place is the heading, named once, rather than a label repeated on every
 * row. Each item carries the button that deals with it.
 */
export function TodoByPlace({ groups }: { groups: TodoGroup[] }) {
  if (groups.length === 0) return null
  return (
    <section aria-labelledby="home-todo" className={styles.section} data-panel="To do">
      <div className={styles.sectionHead}>
        <h2 id="home-todo" className={styles.sectionTitle}>To do</h2>
      </div>
      <div>
        {groups.map((group) => (
          <div key={group.key} className={styles.todoGroup} data-todo-group={group.place?.name ?? 'Your account'}>
            <div className={styles.todoPlace}>
              {group.place && (
                <span className={styles.placeMark}>
                  {group.place.logoUrl
                    ? <img src={group.place.logoUrl} alt="" className={styles.placeLogo} />
                    : <span className={styles.placeInitial} aria-hidden="true">{group.place.name.slice(0, 1)}</span>}
                  {group.place.color && <span className={styles.brandRule} style={{ background: group.place.color }} aria-hidden="true" />}
                </span>
              )}
              <span className={styles.placeText}>
                <span className={styles.placeName}>{group.place?.name ?? 'Your account'}</span>
                {group.place?.role && <span className={styles.placeRole}>{group.place.role}</span>}
              </span>
            </div>
            <ul className={styles.todoItems}>
              {group.items.map((item) => (
                <li key={item.id} className={styles.todoItem}>
                  <span className={styles.todoText}>
                    <span className={styles.todoTitle}>{item.title}</span>
                    {item.description && <span className={styles.todoDesc}>{item.description}</span>}
                  </span>
                  {item.actionTo && item.actionLabel && (
                    <ActionLink to={item.actionTo} variant="secondary">{item.actionLabel}</ActionLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}
